// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import {
  type ImportedPricingCompany,
  type ImportedPricingCompanyWireFormat,
  NewImportedPricingCompany,
} from '../ImportedPricingCompany/ImportedPricingCompany';
import {
  type ImportedPricingProduct,
  type ImportedPricingProductWireFormat,
  NewImportedPricingProduct,
} from '../ImportedPricingProduct/ImportedPricingProduct';
import { type NamedRef, type NamedRefWireFormat, NewNamedRef } from '../NamedRef/NamedRef';

export class ImportedPricing {
  readonly id: string;
  readonly name: string;
  readonly externalID: string | null;
  readonly integrationID: string | null;
  readonly allCompanies: boolean;
  readonly companies: ImportedPricingCompany[];
  readonly products: ImportedPricingProduct[];
  readonly locations: NamedRef[];
  readonly createdBy: NamedRef | null;
  readonly isArchived: boolean;
  readonly createdAt: DateTime;
  readonly updatedAt: DateTime;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.externalID = data.externalID === undefined ? null : data.externalID;
    this.integrationID = data.integrationID === undefined ? null : data.integrationID;
    this.allCompanies = data.allCompanies === undefined ? false : data.allCompanies;
    this.companies = (data.companies ?? []).map((companies: any) =>
      NewImportedPricingCompany(companies),
    );
    this.products = (data.products ?? []).map((products: any) =>
      NewImportedPricingProduct(products),
    );
    this.locations = (data.locations ?? []).map((locations: any) => NewNamedRef(locations));
    this.createdBy =
      // eslint-disable-next-line no-nested-ternary
      (data.createdBy ?? null) === null ? null : NewNamedRef(data.createdBy);
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
    this.createdAt = DateHelpers.ParseServerDateTime(data.createdAt);
    this.updatedAt = DateHelpers.ParseServerDateTime(data.updatedAt);
  }

  static zero(): ImportedPricing {
    const zeroValues: ExcludeMethodsDeep<ImportedPricing> = {
      id: NIL_UUID,
      name: '',
      externalID: null,
      integrationID: null,
      allCompanies: false,
      companies: [],
      products: [],
      locations: [],
      createdBy: null,
      isArchived: false,
      createdAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
      updatedAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
    };
    return new ImportedPricing(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ImportedPricingWireFormat = {
  id: string;
  name: string;
  externalID: string | null;
  integrationID: string | null;
  allCompanies: boolean;
  companies: ImportedPricingCompanyWireFormat[];
  products: ImportedPricingProductWireFormat[];
  locations: NamedRefWireFormat[];
  createdBy: NamedRefWireFormat | null;
  isArchived: boolean;
  createdAt: string;
  updatedAt: string;
};

type NewImportedPricingProps = PartialDeep<ImportedPricing, { recurseIntoArrays: true }>;
export const NewImportedPricing: (props: NewImportedPricingProps) => ImportedPricing = (props) =>
  new ImportedPricing(props);

type NewImportedPricingFromWireFormatProps = PartialDeep<
  ImportedPricingWireFormat,
  { recurseIntoArrays: true }
>;
export const NewImportedPricingFromWireFormat: (
  props: NewImportedPricingFromWireFormatProps,
) => ImportedPricing = (props) => new ImportedPricing(props);
